const LoadingState = {
  UNINITIALIZED: "UNINITIALIZED",
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED"
} as const;

type LoadingStateType = typeof LoadingState[keyof typeof LoadingState];

const ALL = Object.values(LoadingState);

export const combineLoadingStates = (
  loadingStates: LoadingStateType[]
): LoadingStateType => {
  return loadingStates.reduce((previousState, currentState) => {
    switch (previousState) {
      case LoadingState.FAILED:
        return LoadingState.FAILED;
      default:
        switch (currentState) {
          case LoadingState.UNINITIALIZED:
          case LoadingState.FAILED:
            return currentState;
          default:
            if (
              previousState === LoadingState.COMPLETED &&
              currentState === LoadingState.COMPLETED
            ) {
              return LoadingState.COMPLETED;
            }

            return LoadingState.IN_PROGRESS;
        }
    }
  }, LoadingState.COMPLETED);
};

export default { ...LoadingState, ALL };
